let pendingCart;

function readCart() {
  if (!pendingCart) {
    const root = window.Shopify?.routes?.root || '/';
    const request = fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(response => {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .finally(() => { if (pendingCart === request) pendingCart = null; });
    pendingCart = request;
  }
  return pendingCart;
}

class SmoonCartGoal extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.version = (this.version || 0) + 1;
    this.paint({ item_count: Number(this.dataset.itemCount), total_price: Number(this.dataset.totalPrice) });
    const signal = this.controller.signal;
    const update = event => {
      pendingCart = null;
      const cart = event.detail?.resource || event.detail?.cart;
      if (Number.isFinite(cart?.item_count) && Number.isFinite(cart?.total_price)) {
        clearTimeout(this.timer);
        this.version++;
        this.paint(cart);
      } else {
        this.version++;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.refresh(), 100);
      }
    };
    document.addEventListener('cart:update', update, { signal });
    document.addEventListener('cart:updated', update, { signal });
    document.addEventListener('discount:update', update, { signal });
    window.addEventListener('pageshow', event => {
      if (event.persisted) update(event);
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    clearTimeout(this.timer);
    this.version++;
  }

  async refresh() {
    const version = this.version;
    try {
      const cart = await readCart();
      if (this.isConnected && version === this.version) this.paint(cart);
    } catch (error) {
      console.warn('Cart progress could not be refreshed.', error);
    }
  }

  paint(cart) {
    const goal = Number(this.dataset.goalValue);
    if (!(goal > 0)) return;
    const quantityGoal = this.dataset.goalType === 'quantity';
    const current = quantityGoal ? cart.item_count : cart.total_price / 100;
    const message = this.querySelector('[data-message]');
    const progress = this.querySelector('[data-progress-bar]');
    const success = this.querySelector('[data-success]');
    if (!Number.isFinite(current) || !message || !progress || !success) return;
    const reached = current >= goal;
    progress.style.width = `${Math.min(current / goal * 100, 100)}%`;
    message.classList.toggle('hidden', reached);
    success.classList.toggle('active', reached);
    if (reached) {
      success.textContent = this.dataset.successMessage;
    } else {
      const remaining = Math.max(goal - current, 0);
      const formatted = quantityGoal ? Math.ceil(remaining) : new Intl.NumberFormat('hu-HU', {
        style: 'currency', currency: this.dataset.currency || 'HUF'
      }).format(remaining);
      message.textContent = (this.dataset.progressMessage || '').replace('{remaining}', formatted);
    }
  }
}

if (!customElements.get('smoon-cart-goal')) customElements.define('smoon-cart-goal', SmoonCartGoal);
